// src/api/endpoints/tasks.ts
import api from '../client';
import { Task, ApiResponse } from '@/types';

interface TasksResponse {
  tasks: Task[];
  pagination: {
    total: number;
    pages: number;
    page: number;
    limit: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
  stats: Array<{
    _id: string;
    count: number;
    totalTime: number;
    estimatedTime: number;
  }>;
filterCounts: {
    [key: string]: {
      count: number;
      totalTime: number;
    };
  };
}

interface BulkUpdateResponse {
  updated: number;
}

export const tasksApi = {
  getTasks: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    priority?: string;
    client?: string;
    teamLeader?: string;
    allottedTo?: string;
    dueDateFrom?: string;
    dueDateTo?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }) => api.get<TasksResponse>('/tasks', { params,
  //   headers: {
  //   'Cache-Control': 'no-store',
  // } 
}),
   
  getTaskCounts: () => api.get("/tasks/counts"),

  getTask: (id: string) => 
    api.get<ApiResponse<{ task: Task }>>(`/tasks/${id}`),
  
  createTask: (data: {
    client: string;
    task: string;
    subTask: string;
    et: number;
    allottedTo: string;
    teamLeader: string;
    priority: 'Low' | 'Medium' | 'High';
    dueDate: string;
    frequency: 'None' | 'Monthly' | 'Quarterly' | 'Yearly';
  }) => api.post<ApiResponse<{ task: Task }>>('/tasks', data),
  
  updateTask: (id: string, data: Partial<Task>) => 
    api.put<ApiResponse<{ task: Task }>>(`/tasks/${id}`, data),
  
  deleteTask: (id: string) => 
    api.delete<ApiResponse<null>>(`/tasks/${id}`),
  
  bulkUpdateTasks: (ids: string[], updates: Partial<Task>) => 
    api.post<BulkUpdateResponse>('/tasks/bulk-update', { ids, updates }),
  
  bulkDeleteTasks: (ids: string[]) => 
    api.post<ApiResponse<{ deleted: number }>>('/tasks/bulk-delete', { ids }),
  
  getOverdueTasks: () => 
    api.get<ApiResponse<{ tasks: Task[] }>>('/tasks/overdue'),
  
  getTasksDueToday: () => 
    api.get<ApiResponse<{ tasks: Task[] }>>('/tasks/due-today'),
  
  exportTasks: (format: 'csv' | 'excel' = 'csv') => 
    api.get('/tasks/export', { 
      params: { format },
      responseType: 'blob' 
    }),
  
  importTasks: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post<ApiResponse<{ imported: number }>>('/tasks/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  addQuotation: (id: string, data: { amount: number; remarks?: string }) => 
    api.post<ApiResponse<{ task: Task }>>(`/tasks/${id}/quotation`, data),
  
  getTaskTimeEntries: (id: string) => 
    api.get<ApiResponse<{ timeEntries: any[] }>>(`/tasks/${id}/time-entries`),
  
  addTimeEntry: (id: string, data: { minutes: number; date?: string; description?: string }) => 
    api.post<ApiResponse<{ timeEntry: any }>>(`/tasks/${id}/time-entries`, data),


};